/* istanbul ignore file */
import React from 'react';
import Modal from 'react-bootstrap/Modal';

import ButtonSecondary from '@components/shared/buttons/ButtonSecondary/ButtonSecondary';

import styles from './ActionModal.module.scss';

export interface IModalAction {
  icon: React.ReactNode;
  title: string;
  onClick: () => void;
}

interface IActionModalProps {
  onClose?: () => void;
  actions: IModalAction[];
}

/**
 * Pop-up menu modal that presents the user with a list of actions to take.
 *
 * @param actions The contents of the menu.  Each contains an icon, a title, and a click handler
 * @param onClose The action to take when the modal is closed, if any
 */
const ActionModal = ({
  onClose = () => {},
  actions,
}: IActionModalProps) => {
  return (
    <Modal
      animation={false}
      backdropClassName={ styles.Backdrop }
      dialogClassName={ styles.ModalDialog }
      onHide={ onClose }
      show
    >
      <div className={ styles.Content }>
        {
          actions.map((action) => (
            <div>
              <button
                type="button"
                className={ styles.ActionButton }
                onClick={ action.onClick }
              >
                <span className={ `${styles.Icon} btn` }>
                  {action.icon}
                </span>
                <span>{action.title}</span>
              </button>
            </div>
          ))
        }
        <div className={styles.CloseButtonContainer}>
          <ButtonSecondary onClick={ onClose } className={styles.CloseButton}>
            Close
          </ButtonSecondary>
        </div>
      </div>
    </Modal>
  );
};

export default ActionModal;
